import React from 'react';
import { GenericDialog } from '@AMIEWEB/Alerts/GenericDialog';
import { useTranslation } from 'react-i18next';
import { colors } from 'styles/styleVariables';
import { selectPlacementDetails } from 'store/redux-store/placement-details/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { placementDocumentsActions } from 'store/redux-store/placement-documents/slice';

export const CredentialingPacketDialog = (props: {
  open: boolean;
  documentId: string;
  handleClose: () => void;
}) => {
  const { open, documentId, handleClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const placementDetails = useSelector(selectPlacementDetails);

  const handleUpdate = () => {
    dispatch(
      placementDocumentsActions.updateCredentialingDocStatus({
        placementId: placementDetails?.header?.placementId,
        documentId: documentId,
      }),
    );
    handleClose();
  };

    return (
      <GenericDialog
        open={open}
        dialogTitleProps={{ text: t('placement.profile.tabs.documentTab.sendDocumentTitle') }}
        maxWidth="sm"
        dialogActions={[
          {
            text: t('placement.profile.tabs.documentTab.notNow'),
            variant: 'text',
            color: 'tertiary',
            onClick: () => handleClose(),
          },
          {
            text: t('placement.profile.tabs.documentTab.markAsSent'),
            variant: 'contained',
            onClick: () => handleUpdate(),
          },
        ]}
      ><span style={{ fontSize: '14px', color: colors.black }}> {t('placement.profile.tabs.documentTab.sendDocumentDescription')} </span></GenericDialog>
  );
};